import { HomeOrganizationAnnouncementFormPage } from './HomeOrganizationAnnouncementFormPage';
export default HomeOrganizationAnnouncementFormPage;
